<template>
  <div>
    <ion-toolbar>
      
      <ion-buttons slot="start">
        <ion-button class="button_back" @click="goBack">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <!-- <ion-buttons slot="end">
        <ion-button @click="skip">
          <span>Skip</span>
        </ion-button>
      </ion-buttons> -->
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
      <div class="container">
        
        <div class="auth-header">
          <div class="auth-heading">
            <h1>Date of Birth</h1>
          </div>
          <div class="brand-icon">
            <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
          </div>
        </div>
        <el-form
          class="full_page"
          :model="formsData.userForm"
          :rules="formsData.userForm.rules"
          :ref="(el) => (formsData.userForm.ref = el)"
          :label-position="'top'"
          @submit.prevent="goNext('userForm')"
        >
          <div class="form_text">
            <div class="text">
              We need your date of birth to verify your registration with AHPRA
            </div>
          </div>
          <el-form-item class="no-scroll" prop="birthday" :required="true">
            <el-date-picker
              popper-class="datepicker_popper"
              v-model="formsData.userForm.birthday.valueFormatted"
              type="date"
              placeholder="Date of Birth"
              :format="$filters.systemDateFormat()"
              :editable="false"
              :disabled-date="formsData.userForm.birthday.disabledDate"
              @change="dateConvert"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item class="button_submit button_submit mb0">
            <el-button
              class="submit"
              type="blue"
              @click="goNext('userForm')"
              :disabled="formsData.userForm.disabled"
            >
              Continue <i class="el-icon-right"></i>
            </el-button>
          </el-form-item>
        </el-form>

        <div class="background-circles">
                    <div class="circle circle-2"></div>
                    <div class="circle circle-1"></div>
                    <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
                </div>
                
      </div>
    </div>
  </div>
</template>

<script>
import { ElMessageBox } from "@/components/Vendor/Element";
import { onMounted, inject, } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";

import { useStore } from "vuex";

import { useRouter, useRoute } from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";
import SvgIcon from '@/components/Svg/SvgIcon.vue';

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    SvgIcon
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    const setPageClassGlobal = inject(["setPageClassGlobal"]);
    const $moment = inject(["$moment"]);

    const userData = $store.getters.GET_USER_DATA;

    const dateConvert = () => {
      if (formsData.userForm.birthday.valueFormatted) {
        const result = $moment(formsData.userForm.birthday.valueFormatted, "YYYY-MM-DD").format(
          "YYYY-MM-DD")
        formsData.userForm.birthday.value = result
      } else {
        return null;
      }
    };

    const birthdayValue = userData.birthday
      ? $moment(userData.birthday, ["YYYY-MM-DD"])
      : new Date(new Date().setFullYear(new Date().getFullYear() - 21));

    const formsDataArray = {
      userForm: {
        ref: null,
        birthday: {
          value: userData.birthday ? userData.birthday : null,
          // valueFormatted: null,
          // disabledDate: null,
          // value: dateConvert || $moment(birthdayValue).format("YYYY-MM-DD"),
          valueFormatted: birthdayValue,
          disabledDate: (time) => {
            let dateNow = new Date().setFullYear(new Date().getFullYear() - 18);
            return (
              time.getTime() >
              new Date(dateNow).setDate(new Date(dateNow).getDate())
            );
          },
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "birthday",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
      },
    };

    const goBack = () => {
      $router.push({
          name: 'onboard_name',
      })
    };

    const goNext = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          (async () => {
            try {
              await $store.dispatch("SAVE_USER_DATA", getFormValues(formName));
              $router.push({
                name: "onboard_gender",
              });
            } catch (error) {
              console.log(error);
            }
          })();
        } else {
          setFormValidation(formName, false, false);
          console.log("error submit!!");
          return false;
        }
      });
    };

    const skip = () => {
      (async () => {
        try {
          await ElMessageBox.confirm(
            ``,
            "Do you want to skip? You will be unverified",
            {
              distinguishCancelAndClose: true,
              showConfirmButton: true,
              confirmButtonText: "Skip",
              cancelButtonText: "Cancel",
              confirmButtonClass: "el-button--green",
              cancelButtonClass: "el-button--grey",
              showClose: true,
            }
          );
        } catch {
          return;
        }
        try {
          await $store.dispatch("addAuthPageBack", $route.name);
          $router.push({
            name: "onboard_gender",
          });
        } catch (error) {
          console.log(error);
        }
      })();
    };

    onMounted(() => {
      setPageClassGlobal("global_onboard_internal_page");
      setFormRefs();
      checkFormValidation("userForm", false);
      dateConvert();
    });

    const {
      checkFormValidation,
      setFormValidation,
      getFormValues,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    return {
      dateConvert,
      formsData,
      goBack,
      goNext,
      skip,
    };
  },
};
</script>
